var map = {
	"./loadModelAndEnv": [
		9553,
		170,
		627,
		553
	],
	"./loadModelAndEnv.ts": [
		9553,
		170,
		627,
		553
	],
	"./physicsWithAmmo": [
		6419,
		170,
		842,
		690
	],
	"./physicsWithAmmo.ts": [
		6419,
		170,
		842,
		690
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8386;
module.exports = webpackAsyncContext;